module.exports = __webpack_public_path__ + "static/2-a98e4e8c6b54cb27ba9292e0db717d50.jpg";